import { render, staticRenderFns } from "./main-sidebar.vue?vue&type=template&id=6acebfad&scoped=true&"
import script from "./main-sidebar.ts?vue&type=script&lang=ts&"
export * from "./main-sidebar.ts?vue&type=script&lang=ts&"
import style0 from "./main-sidebar.vue?vue&type=style&index=0&id=6acebfad&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6acebfad",
  null
  
)

export default component.exports